// TODO: cleanup with cp_annotation_createproject_agent ff

export interface AgentSectionDraftValues {
  heading: string;
  body: string;
}

export interface AgentSectionErrors {
  heading: boolean;
  body: boolean;
}

/** Both fields are mandatory; a value of only whitespace counts as blank. */
export const validateAgentSectionDraft = ({
  heading,
  body,
}: AgentSectionDraftValues): AgentSectionErrors => ({
  heading: heading.trim() === '',
  body: body.trim() === '',
});
